import React from "react";

const ResourceNotAvailable = () => {
    return (
        <React.Fragment>
            <div className="row justify-content-center mt-5">
                <div className="col-6 mt-5 text-center">
                    <h1 style={{ color: "#91B8C1" }}><i className="fad fa-meh-blank" style={{ color: "#FF7C1F" }}></i>  Resource Not Available</h1>
                    <p className="mt-5">The page you are trying to view is not availble.</p>
                    <p>Either it doesn't exist or you don't have access to it.</p>
                </div>
            </div>
            </React.Fragment>
        )
}

    

export default ResourceNotAvailable; 


// WEBPACK FOOTER //
// ./src/components/ResourceNotAvailable.js